import { useState } from 'react';
import { isAndroid } from 'react-device-detect';

import {
  AddToHomeScreenGuideTemplate,
  PlatformType,
} from '../../components/Templates';

const AddToHomeGuideScreen: React.FC = () => {
  const [platform, setPlatform] = useState<PlatformType>(
    isAndroid ? PlatformType.Android : PlatformType.IOS,
  );

  return (
    <AddToHomeScreenGuideTemplate
      platformType={platform}
      onSwitchTab={setPlatform}
    />
  );
};

export default AddToHomeGuideScreen;
